document.addEventListener('DOMContentLoaded', async function () {
    
    function openSidebar(sidebarId) {
        const sidebar = document.getElementById(sidebarId);
        const overlay = document.getElementById('sidebarOverlay');
        document.body.classList.add('sidebar-open'); 
        if (sidebar) {
            sidebar.classList.add('open');
            overlay.classList.add('active');
        }
    }
    function closeSidebar(sidebarId) {
        const sidebar = document.getElementById(sidebarId);
        const overlay = document.getElementById('sidebarOverlay');
  
        if (sidebar) {
            sidebar.classList.remove('open');
         document.body.classList.remove('sidebar-open');
        }
  
        // Check if any sidebar is still open
        const anyOpenSidebar = document.querySelector('.right-sidebar.open');
        if (!anyOpenSidebar) {
            overlay.classList.remove('active');
         document.body.classList.remove('sidebar-open');
          
        }
    }
    function closeAllSidebars() {
        const sidebars = document.querySelectorAll('.right-sidebar');
        const overlay = document.getElementById('sidebarOverlay');
  
        sidebars.forEach(sidebar => sidebar.classList.remove('open'));
        overlay.classList.remove('active');
         document.body.classList.remove('sidebar-open');
      
    }

    window.openSidebar = openSidebar;
    window.closeSidebar = closeSidebar;
    window.closeAllSidebars = closeAllSidebars;
  
})